import type { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios'

import { getApiErrorMessage } from '@/data/api/types'
import { isDev, isLocal, isProd } from '@/utils/env'

const shouldLog = () => !isProd() && (isLocal() || isDev())

export const loggerInterceptor = {
  request: (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    if (shouldLog()) {
      console.debug('[api:request]', config.method?.toUpperCase(), config.url)
    }

    return config
  },
  response: (response: AxiosResponse): AxiosResponse => {
    if (shouldLog()) {
      console.debug('[api:response]', response.status, response.config.url)
    }

    return response
  },
  responseError: (error: AxiosError): Promise<never> => {
    if (shouldLog()) {
      console.debug('[api:error]', error.response?.status, error.config?.url, getApiErrorMessage(error))
    }

    return Promise.reject(error)
  },
}
